import { ECurrentUserGroupActions } from '../actions/current-user-group.actions';
import { ECurrentUserGroupStatus } from '../../../core/user-groups.enum';

export const initialUserGroupState: ICurrentUserGroupState = {
  isLoading: false,
  status: ECurrentUserGroupStatus.EMPTY,
  currentGroup: {
    conditions: [],
    description: '',
    displayName: '',
    id: '',
    name: '',
    users: [],
    userOperations: {
      toAdd: {},
      toModify: {},
      toRemove: {}
    }
  }

}

export function currentUserGroupsReducers(state = initialUserGroupState, action: any): ICurrentUserGroupState {
  switch (action.type) {

    case ECurrentUserGroupActions.StartNewUserGroup: {
      const newState = {
        ...initialUserGroupState,
        status: ECurrentUserGroupStatus.NEW
      };
      return newState;
    }

    case ECurrentUserGroupActions.GetCurrentUserGroup: {
      const newState = {
        ...state,
        isLoading: true,
        status: ECurrentUserGroupStatus.EDIT
      };
      return newState;
    }

    case ECurrentUserGroupActions.GetCurrentUserGroupSuccess: {
      const newState = {
        ...state,
        currentGroup: action.payload.userOperations ? { ...action.payload } : {
          ...action.payload, userOperations: {
            toAdd: {},
            toModify: {},
            toRemove: {}
          }
        },
        isLoading: false
      };
      return newState;
    }

    case ECurrentUserGroupActions.UpdateUserGroup: {
      const newState = {
        ...state,
        isLoading: true
      };
      return newState;
    }

    case ECurrentUserGroupActions.UpdateUserGroupSuccess: {
      const newState = {
        ...state,
        isLoading: false
      };
      return newState;
    }

    case ECurrentUserGroupActions.UpdateLocalUserGroup: {
      const newState = {
        ...state,
        currentGroup: _.cloneDeep(action.payload),
        isLoading: false
      };
      return newState;
    }

    case ECurrentUserGroupActions.SetCurrentGroup: {
      const newState = {
        ...state,
        currentGroup: { ...action.payload }
      };
      return newState;
    }

    case ECurrentUserGroupActions.AddSpecificUser: {
      if (!state.currentGroup.userOperations) {
        state.currentGroup.userOperations = { toAdd: {}, toModify: {}, toRemove: {} };
      }
      const userExistInAdd = state.currentGroup.userOperations.toAdd[action.payload.id];
      const userExistInModify = state.currentGroup.userOperations.toModify[action.payload.id];
      const userExistInRemove = state.currentGroup.userOperations.toRemove[action.payload.id];

      const currentUser = state.currentGroup.users.find((user: IUserGroupUser) => {
        return user.id === action.payload.id;
      });

      if (userExistInAdd || userExistInModify || currentUser) {
        return state;
      }

      let userOperations: IUsersOperations;
      if (!userExistInAdd && !userExistInRemove) {
        const newToAdd = {};
        newToAdd[action.payload.id] = true;
        userOperations = {
          ...state.currentGroup.userOperations,
          toAdd: {
            ...state.currentGroup.userOperations.toAdd,
            ...newToAdd
          }
        }
      }

      if (!userExistInAdd && userExistInRemove) {
        const toRemove = { ...state.currentGroup.userOperations.toRemove };
        delete toRemove[action.payload.id];
        userOperations = {
          ...state.currentGroup.userOperations,
          toRemove: {
            ...toRemove
          }
        }
      }

      const newState = {
        ...state,
        currentGroup: {
          ...state.currentGroup,
          users: [...state.currentGroup.users, action.payload],
          userOperations: userOperations ? userOperations : { ...state.currentGroup.userOperations }
        }
      };
      return newState;
    }

    case ECurrentUserGroupActions.ModifySpecificUser: {
      const currentUser = state.currentGroup.users.find((user: IUserGroupUser) => {
        return user.id === action.payload.id;
      });

      if (!currentUser) {
        return state;
      }

      const usersTemporal: Array<IUserGroupUser> = [...state.currentGroup.users];
      const userIndex = usersTemporal.findIndex((user: IUserGroupUser) => {
        return user.id === currentUser.id;
      });
      usersTemporal[userIndex] = action.payload;

      const userExistInModify = state.currentGroup.userOperations.toModify[action.payload.id];
      const userExistInAdd = state.currentGroup.userOperations.toAdd[action.payload.id];
      let userOperations: IUsersOperations;
      if (!userExistInModify && !userExistInAdd) {
        const newToModify = {};
        newToModify[action.payload.id] = true;
        userOperations = {
          ...state.currentGroup.userOperations,
          toModify: {
            ...state.currentGroup.userOperations.toModify,
            ...newToModify
          }
        }
      }

      const newState = {
        ...state,
        currentGroup: {
          ...state.currentGroup,
          users: [...usersTemporal],
          userOperations: userOperations ? userOperations : { ...state.currentGroup.userOperations }
        },
      };
      return newState;
    }

    case ECurrentUserGroupActions.DeleteSpecificUser: {
      const userExistInModify = state.currentGroup.userOperations.toModify[action.payload];
      const userExistInAdd = state.currentGroup.userOperations.toAdd[action.payload];
      let userOperations: IUsersOperations;

      if (!userExistInModify && !userExistInAdd) {
        const newToRemove = {};
        newToRemove[action.payload] = true;
        userOperations = {
          ...state.currentGroup.userOperations,
          toRemove: {
            ...state.currentGroup.userOperations.toRemove,
            ...newToRemove
          }
        }
      } else if (userExistInModify && !userExistInAdd) {
        const newToRemove = {};
        newToRemove[action.payload] = true;
        const toModify = { ...state.currentGroup.userOperations.toModify };
        delete toModify[action.payload];
        userOperations = {
          ...state.currentGroup.userOperations,
          toRemove: {
            ...state.currentGroup.userOperations.toRemove,
            ...newToRemove
          },
          toModify: {
            ...toModify
          }
        }
      } else if (!userExistInModify && userExistInAdd) {
        const toAdd = { ...state.currentGroup.userOperations.toAdd };
        delete toAdd[action.payload];
        userOperations = {
          ...state.currentGroup.userOperations,
          toAdd: {
            ...toAdd
          }
        }
      }

      const currentUser = state.currentGroup.users.find((user: IUserGroupUser) => {
        return user.id === action.payload;
      });

      const usersTemporal: Array<IUserGroupUser> = [...state.currentGroup.users];

      const userIndex = usersTemporal.findIndex((user: IUserGroupUser) => {
        return user.id === currentUser.id;
      });

      usersTemporal.splice(userIndex, 1);

      const newState = {
        ...state,
        currentGroup: {
          ...state.currentGroup,
          users: [...usersTemporal],
          userOperations: userOperations ? userOperations : { ...state.currentGroup.userOperations }
        }
      };
      return newState;
    }

    case ECurrentUserGroupActions.ResetCurrentUserGroup: {
      const newState = {
        ...initialUserGroupState
      };
      return newState;
    }

    case ECurrentUserGroupActions.CreateUserGroup: {
      const newState = {
        ...state,
        isLoading: true
      }
      return newState;
    }

    case ECurrentUserGroupActions.CreateUserGroupSuccess: {
      const userGroupCreated = action.payload;
      const newState = {
        ...state,
        currentGroup: userGroupCreated,
        isLoading: false
      }
      return newState;
    }

    default:
      return state;
  }
};

export const getCurrentUserGroup = (state: IUserGroup) => state;